import RuleApi from '@/api/RuleApi';
import store from '../store/index';
import router from '../router/index';

export default {
  ensureLoggedIn() {
    if (!store.getters.loggedIn(Date.now())) {
      router.push('/login');
    }
  },

  // List rules
  async getAllCollectionPages(
    tenantUUID: string,
    params: any = {}
  ): Promise<any[]> {
    this.ensureLoggedIn();

    const rules: any[] = [];
    const pageResponses = await RuleApi.getAllCollectionPages(
      tenantUUID,
      params
    );

    pageResponses.forEach((response: any) => {
      response.data.data.forEach((ruleObj: any) => {
        rules.push({
          uuid: ruleObj.id,
          name: ruleObj.attributes.name,
          description: ruleObj.attributes.description,
          scopeEntityType: ruleObj.attributes.scopeEntityType,
          scopeTriggers: ruleObj.attributes.scopeTriggers,
          scopeFilters: ruleObj.attributes.scopeFilters,
          actions: ruleObj.attributes.actions,
          createdAt: ruleObj.meta.createdAt,
          updatedAt: ruleObj.meta.updatedAt,
          deletedAt: ruleObj.meta.deletedAt,
        });
      });
    });

    return rules;
  },

  // Single rule
  async getSingle(tenantUUID: string, ruleUUID: string): Promise<any> {
    this.ensureLoggedIn();

    const response = await RuleApi.getSingle(tenantUUID, ruleUUID);
    const ruleObj = response.data.data;

    return {
      uuid: ruleObj.id,
      name: ruleObj.attributes.name,
      description: ruleObj.attributes.description,
      scopeEntityType: ruleObj.attributes.scopeEntityType,
      scopeTriggers: ruleObj.attributes.scopeTriggers,
      scopeFilters: ruleObj.attributes.scopeFilters,
      actions: ruleObj.attributes.actions,
      createdAt: ruleObj.meta.createdAt,
      updatedAt: ruleObj.meta.updatedAt,
      deletedAt: ruleObj.meta.deletedAt,
    };
  },

  // Create rule
  async createRule(tenantUUID: string, attributes: any): Promise<any> {
    this.ensureLoggedIn();

    const response = await RuleApi.createRule(tenantUUID, attributes);

    if (response.data.data.type && response.data.data.type === 'rules') {
      const ruleObj = response.data.data;

      return {
        uuid: ruleObj.id,
        name: ruleObj.attributes.name,
        description: ruleObj.attributes.description,
        scopeEntityType: ruleObj.attributes.scopeEntityType,
        scopeTriggers: ruleObj.attributes.scopeTriggers,
        scopeFilters: ruleObj.attributes.scopeFilters,
        actions: ruleObj.attributes.actions,
        createdAt: ruleObj.meta.createdAt,
        updatedAt: ruleObj.meta.updatedAt,
        deletedAt: ruleObj.meta.deletedAt,
      };
    } else {
      throw TypeError('Response not type rules');
    }
  },

  // Update rule
  async updateRule(
    tenantUUID: string,
    ruleUUID: string,
    attributes: any
  ): Promise<any> {
    this.ensureLoggedIn();

    const response = await RuleApi.updateRule(tenantUUID, ruleUUID, attributes);

    if (response.data.data.type && response.data.data.type === 'rules') {
      const ruleObj = response.data.data;

      return {
        uuid: ruleObj.id,
        name: ruleObj.attributes.name,
        description: ruleObj.attributes.description,
        scopeEntityType: ruleObj.attributes.scopeEntityType,
        scopeTriggers: ruleObj.attributes.scopeTriggers,
        scopeFilters: ruleObj.attributes.scopeFilters,
        actions: ruleObj.attributes.actions,
        createdAt: ruleObj.meta.createdAt,
        updatedAt: ruleObj.meta.updatedAt,
        deletedAt: ruleObj.meta.deletedAt,
      };
    } else {
      throw TypeError('Response not type rules');
    }
  },

  // Delete rule
  async deleteRule(
    tenantUUID: string,
    ruleUUID: string,
    removeActionEntities = true
  ): Promise<void> {
    this.ensureLoggedIn();
    await RuleApi.deleteRule(tenantUUID, ruleUUID, removeActionEntities);
  },
};
